import { Component, Input, OnInit } from '@angular/core';
import { combineLatest, Observable, Subject } from 'rxjs';
import { IFlag } from 'Src/ng2/shared/typings/interfaces/flags.interface';
import { unsubscribeComponent } from '../../../shared/helpers/unsubscribe-decorator/unsubscribe-decorators.helper';
import { FlagsFilterService } from '../../../shared/services/filter-services/flags-filter.service';
import {
  ICollectionToMerge,
  StudentCollectionsMergeService,
} from '../../../shared/services/student-collections-merge/student-collections-merge.service';
import { IStudent } from '../../../shared/typings/interfaces/student.interface';
import { IMyStudentsListStudent } from '../../../store/effects/projections';

@Component({
  selector: 'nvps-my-students-list',
  template: require('./my-students-list.component.html'),
})
@unsubscribeComponent
export class MyStudentsListComponent implements OnInit {
  public studentsWithFlags$: Observable<any>;
  public destroy$: Subject<boolean> = new Subject<boolean>();

  @Input() flags$: Observable<IFlag[]>;
  @Input() students$: Observable<IStudent[]>;
  @Input() currentSchool;
  @Input() madlibOptions$;
  @Input() madlibState$;
  @Input() currentUser;
  @Input() batchActionsMode$: Observable<any>;

  constructor(
    private flagsFilterService: FlagsFilterService,
    private studentCollectionsMergeService: StudentCollectionsMergeService,
  ) {}

  ngOnInit(): void {
    this.studentsWithFlags$ = this.mergeStudentsAndCollections(this.students$, this.flags$);
  }

  mergeStudentsAndCollections(
    students$: Observable<IStudent[]>,
    flags$: Observable<IFlag[]>,
  ): Observable<IMyStudentsListStudent[]> {
    return combineLatest(students$, flags$, (students: IStudent[], flags: IFlag[]) => {
      const filteredFlags = this.flagsFilterService.getAllFlagsByCategory(flags);
      const { academicFlags, attendanceFlags } = filteredFlags;

      const studentsWithMergedCollections = this.studentCollectionsMergeService.mergeCollectionsToStudents({
        students,
        collections: [
          {
            collection: attendanceFlags,
            keyToAddToStudent: 'attendanceFlags',
            pathToStudentId: 'studentId',
          } as ICollectionToMerge,
          {
            collection: academicFlags,
            keyToAddToStudent: 'academicFlags',
            pathToStudentId: 'studentId',
          } as ICollectionToMerge,
        ],
      });

      return studentsWithMergedCollections;
    });
  }
}
